/* Admin back-office page */
const AdminPage = () => {
  const D = window.PA_DATA;
  const [section, setSection] = useState("overview");
  return (
    <div data-screen-label="07 Admin — Back-office" style={{display:"flex", minHeight:"100vh"}}>
      <SideNav
        brand="Parcours · Admin"
        section={section}
        onChange={setSection}
        items={[
          { group:"Plateforme", items:[
            ["overview", "house", "Vue d'ensemble"],
            ["orgs", "users", "Organisations"],
            ["communes", "pin", "Communes"],
            ["plans", "sparkle", "Plans & facturation"]
          ]},
          { group:"Modération", items:[
            ["queue", "bell", "File de modération"],
            ["users", "users", "Utilisateurs"]
          ]},
          { group:"Données", items:[
            ["stats", "chart", "Statistiques globales"],
            ["settings", "settings", "Paramètres"]
          ]}
        ]}
      />
      <div style={{flex:1, padding:"36px 48px"}}>
        <AdminHeader/>
        {section === "overview" && <AdminOverview/>}
        {section === "orgs"     && <AdminOrgs/>}
        {section === "communes" && <AdminCommunes/>}
        {section === "plans"    && <AdminPlans/>}
        {section === "queue"    && <AdminQueue/>}
        {section === "users"    && <AdminUsers/>}
        {section === "stats"    && <AdminStats/>}
        {section === "settings" && <AdminSettings/>}
      </div>
    </div>
  );
};

const SideNav = ({ brand, section, onChange, items }) => (
  <aside className="sidenav" style={{flexShrink:0}}>
    <div className="row gap-3" style={{padding:"6px 14px 24px"}}>
      <BrandMark size={28}/>
      <div className="stack" style={{lineHeight:1}}>
        <span className="serif-it" style={{fontSize:18}}>Parcours</span>
        <span className="mono" style={{fontSize:9, color:"var(--ink-mute)", marginTop:3}}>{brand.includes("Admin") ? "Admin · BW" : "Organisation"}</span>
      </div>
    </div>
    {items.map(group => (
      <div key={group.group}>
        <div className="sidenav-section">{group.group}</div>
        {group.items.map(([id, icon, label]) => (
          <div key={id} className={"sidenav-item " + (section===id ? "active" : "")}
               onClick={() => onChange(id)}>
            <Icon name={icon} size={15}/>
            <span>{label}</span>
          </div>
        ))}
      </div>
    ))}
    <div style={{marginTop:"auto", paddingTop:32}}>
      <div className="row gap-3" style={{padding:"14px"}}>
        <div className="ph ph-paint-3" style={{width:36, height:36, borderRadius:50}}/>
        <div className="stack" style={{lineHeight:1.2}}>
          <span style={{fontSize:13}}>{brand.includes("Admin") ? "Marie Dupuis" : "C. cult. Genappe"}</span>
          <span className="mono muted">{brand.includes("Admin") ? "Super-admin" : "Organisateur"}</span>
        </div>
      </div>
      <a href="/" className="sidenav-item"><Icon name="logout" size={15}/> Quitter</a>
    </div>
  </aside>
);

const AdminHeader = () => (
  <div className="row between" style={{marginBottom:36}}>
    <div className="stack gap-2">
      <span className="mono muted">Tableau de bord · Brabant wallon</span>
      <h2 style={{fontSize:42}}>Bonjour, <span className="serif-it">Marie.</span></h2>
    </div>
    <div className="row gap-3">
      <div className="search-bar" style={{width:320}}>
        <Icon name="search" size={16}/>
        <input placeholder="Rechercher partout..."/>
        <span className="mono muted" style={{paddingRight:14}}>⌘K</span>
      </div>
      <button className="btn btn-icon btn-light"><Icon name="bell" size={16}/></button>
      <button className="btn btn-primary"><Icon name="plus" size={14}/> Nouveau</button>
    </div>
  </div>
);

const AdminKpi = ({ label, value, delta, deltaColor="var(--sage-d)", chart }) => (
  <div className="panel stack gap-3" style={{padding:24, flex:1, minWidth:0}}>
    <div className="row between">
      <span className="mono muted">{label}</span>
      <span className="mono" style={{color: deltaColor}}>{delta}</span>
    </div>
    <div className="serif" style={{fontSize:52, lineHeight:1}}>{value}</div>
    <div style={{height:36}}>{chart}</div>
  </div>
);

const SparkLine = ({ color="var(--terracotta)", points }) => {
  const pts = points || [4,6,5,8,7,9,11,10,13,15,14,18];
  const max = Math.max(...pts), min = Math.min(...pts);
  const w = 200, h = 36;
  const path = pts.map((p,i) => {
    const x = (i/(pts.length-1))*w;
    const y = h - ((p-min)/(max-min))*h;
    return (i===0?"M":"L") + x.toFixed(1) + " " + y.toFixed(1);
  }).join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:"100%", height:"100%"}}>
      <path d={`${path} L${w} ${h} L0 ${h} Z`} fill={color} opacity="0.12"/>
      <path d={path} stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

const AdminOverview = () => (
  <div className="stack gap-6">
    {/* KPI row */}
    <div className="row gap-4">
      <AdminKpi label="Organisations actives" value="32" delta="+4 ce mois" chart={<SparkLine color="var(--terracotta)"/>}/>
      <AdminKpi label="Parcours publiés"      value="48" delta="+8 ce mois" chart={<SparkLine color="var(--ochre)" points={[2,3,4,5,5,7,8,11,13,14,18,20]}/>}/>
      <AdminKpi label="Artistes inscrits"      value="412" delta="+27 ce mois" chart={<SparkLine color="var(--sage)" points={[10,12,15,17,19,22,25,28,31,35,38,42]}/>}/>
      <AdminKpi label="MRR"                    value="2 840€" delta="+12%" chart={<SparkLine color="var(--slate)" points={[5,6,7,9,11,12,13,14,16,18,21,28]}/>}/>
    </div>

    {/* Big chart + side */}
    <div className="row gap-4">
      <div className="panel" style={{flex:2, padding:28}}>
        <div className="row between" style={{marginBottom:24}}>
          <div className="stack gap-2">
            <span className="eyebrow">Activité par jour</span>
            <h3>Visiteurs sur les pages parcours</h3>
          </div>
          <div className="row gap-2">
            {["7j","30j","Tout"].map((p,i) => (
              <button key={p} className={"chip " + (i===1?"chip-active":"")}>{p}</button>
            ))}
          </div>
        </div>
        <BigChart/>
      </div>

      <div className="panel" style={{flex:1, padding:28}}>
        <div className="stack gap-2">
          <span className="eyebrow">Modération</span>
          <h3>File d'attente</h3>
        </div>
        <div className="stack gap-3" style={{marginTop:20}}>
          {[
            ["Nouveau parcours « Métiers d'eau »", "Ville de Nivelles", "Il y a 12 min", "live"],
            ["Photo signalée — Yannick Defossé", "Verrerie de Wavre", "Il y a 45 min", "soon"],
            ["Demande de marque blanche", "Commune de Lasne", "Il y a 3 h", "draft"],
            ["Nouvel artiste — Camille Orban", "Brabant Culture", "Il y a 1 j", "soon"]
          ].map((row, i) => (
            <div key={i} className="row gap-3" style={{padding:"12px 0", borderBottom:"1px dashed var(--line)"}}>
              <div className="ph ph-paint-2" style={{width:36, height:36, borderRadius:10, flexShrink:0}}/>
              <div className="stack gap-1" style={{flex:1, minWidth:0}}>
                <span style={{fontSize:13, lineHeight:1.2}}>{row[0]}</span>
                <span className="mono muted">{row[1]} · {row[2]}</span>
              </div>
              <button className="btn btn-light btn-sm">→</button>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Recent orgs table */}
    <div className="panel" style={{overflow:"hidden"}}>
      <div className="row between" style={{padding:"24px 28px"}}>
        <div className="stack gap-2">
          <span className="eyebrow">Organisations</span>
          <h3>Récemment actives</h3>
        </div>
        <div className="row gap-2">
          <button className="btn btn-light btn-sm"><Icon name="filter" size={12}/> Filtrer</button>
          <button className="btn btn-light btn-sm">Exporter</button>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Organisation</th><th>Plan</th><th>Parcours</th><th>Artistes</th><th>Statut</th><th>Dernière activité</th><th></th>
          </tr>
        </thead>
        <tbody>
          {[
            ["Centre culturel de Genappe", "Pro", 3, 24, "live", "il y a 2 min"],
            ["Brabant Culture Réseau", "Commune", 12, 86, "live", "il y a 18 min"],
            ["ASBL Soignes Vivantes", "Pro", 1, 18, "soon", "il y a 1 h"],
            ["Ville de Nivelles", "Commune", 4, 31, "live", "il y a 3 h"],
            ["Verrerie de Wavre", "Starter", 1, 9, "past", "il y a 1 j"],
            ["Plateau Cultures", "Pro", 2, 23, "soon", "il y a 2 j"],
            ["Atelier des Foudres", "Pro", 1, 11, "draft", "il y a 4 j"]
          ].map((row,i)=>(
            <tr key={i}>
              <td>
                <div className="row gap-3">
                  <div className={"ph ph-paint-" + ((i%6)+1)} style={{width:36, height:36, borderRadius:10}}/>
                  <span>{row[0]}</span>
                </div>
              </td>
              <td><span className="chip">{row[1]}</span></td>
              <td>{row[2]}</td>
              <td>{row[3]}</td>
              <td><StatusDot status={row[4]}/></td>
              <td className="mono muted">{row[5]}</td>
              <td style={{textAlign:"right"}}><button className="btn btn-icon btn-light" style={{width:32, height:32}}><Icon name="arrow-up-right" size={12}/></button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const BigChart = () => {
  const data = [12,18,15,22,28,35,29,42,48,55,49,62,58,72,68,80,76,88,95,82,98,110,103,118,124,135,128];
  const max = Math.max(...data);
  const w = 700, h = 220;
  const path = data.map((d,i) => {
    const x = (i/(data.length-1))*w;
    const y = h - (d/max)*h*0.9;
    return (i===0?"M":"L") + x.toFixed(1) + " " + y.toFixed(1);
  }).join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h+30}`} style={{width:"100%", height:240}}>
      {/* grid */}
      {[0.25,0.5,0.75].map(p => (
        <line key={p} x1="0" x2={w} y1={h*p} y2={h*p} stroke="var(--line-soft)" strokeDasharray="2 4"/>
      ))}
      <path d={`${path} L${w} ${h} L0 ${h} Z`} fill="url(#fillGrad)"/>
      <path d={path} stroke="var(--terracotta)" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id="fillGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--terracotta)" stopOpacity="0.25"/>
          <stop offset="100%" stopColor="var(--terracotta)" stopOpacity="0"/>
        </linearGradient>
      </defs>
      {data.map((d,i) => i%4===0 && (
        <text key={i} x={(i/(data.length-1))*w} y={h+20} fontSize="9" fill="var(--ink-mute)" fontFamily="JetBrains Mono">{i+1}</text>
      ))}
    </svg>
  );
};

const AdminOrgs = () => (
  <div className="panel" style={{overflow:"hidden"}}>
    <div className="row between" style={{padding:"24px 28px"}}>
      <h3>Toutes les organisations</h3>
      <button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Inviter</button>
    </div>
    <table className="table">
      <thead><tr><th>Organisation</th><th>Type</th><th>Plan</th><th>Parcours</th><th>Statut</th><th></th></tr></thead>
      <tbody>
        {[
          ["Centre culturel de Genappe", "Centre culturel", "Pro", 3, "live"],
          ["Brabant Culture Réseau", "ASBL", "Commune", 12, "live"],
          ["ASBL Soignes Vivantes", "ASBL", "Pro", 1, "soon"],
          ["Ville de Nivelles", "Commune", "Commune", 4, "live"],
          ["Verrerie de Wavre", "Atelier", "Starter", 1, "past"],
          ["Plateau Cultures", "Collectif", "Pro", 2, "soon"],
          ["Atelier des Foudres", "Collectif", "Pro", 1, "draft"],
          ["Collectif Le Libre Papier", "Collectif", "Starter", 1, "soon"]
        ].map((row,i)=>(
          <tr key={i}>
            <td>{row[0]}</td><td>{row[1]}</td><td><span className="chip">{row[2]}</span></td>
            <td>{row[3]}</td><td><StatusDot status={row[4]}/></td>
            <td style={{textAlign:"right"}}>
              <button className="btn btn-icon btn-light" style={{width:32, height:32}}><Icon name="edit" size={12}/></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const AdminCommunes = () => (
  <div className="stack gap-6">
    <div className="row gap-4">
      <AdminKpi label="Communes actives" value="16" delta="+3" chart={<SparkLine color="var(--sage)"/>}/>
      <AdminKpi label="Communes en attente" value="4" delta="" chart={<SparkLine color="var(--ochre)"/>}/>
      <AdminKpi label="Couverture BW" value="59%" delta="+8 pts" chart={<SparkLine color="var(--terracotta)"/>}/>
    </div>
    <div className="panel" style={{padding:0, overflow:"hidden"}}>
      <div className="row between" style={{padding:"24px 28px"}}>
        <h3>Communes raccordées</h3>
        <button className="btn btn-light btn-sm">+ Inviter une commune</button>
      </div>
      <div style={{display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:0}}>
        {window.PA_DATA.communes.map((c,i) => (
          <div key={c.id} style={{padding:24, borderRight: (i%4!==3)?"1px solid var(--line-soft)":"none", borderTop:"1px solid var(--line-soft)"}}>
            <div className="row between">
              <div className="serif" style={{fontSize:22}}>{c.name}</div>
              <span className="chip-dot" style={{background: i%5===4?"var(--status-soon)":"var(--status-live)"}}/>
            </div>
            <div className="mono muted" style={{marginTop:8}}>{1 + (i%3)} parcours · {6+i*2} artistes</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const AdminPlans = () => (
  <div className="stack gap-6">
    <div className="row gap-4">
      {[
        { plan:"Starter", price:"Gratuit", orgs:8, color:"var(--sage)", features:["1 parcours actif","10 artistes max","Statistiques de base","Branding Parcours"] },
        { plan:"Pro", price:"49€/mois", orgs:18, color:"var(--terracotta)", features:["Parcours illimités","Artistes illimités","Statistiques avancées","Export PDF","Domaine personnalisé"], emph:true },
        { plan:"Commune", price:"Sur devis", orgs:6, color:"var(--slate)", features:["Multi-organisations","Marque blanche complète","Support prioritaire","Accompagnement humain","Onboarding artistes"] }
      ].map(p => (
        <div key={p.plan} className={"card stack gap-4 " + (p.emph?"pricing-feature":"")} style={{padding:32, flex:1}}>
          <div className="row between">
            <span className="serif" style={{fontSize:30}}>{p.plan}</span>
            <span className="chip">{p.orgs} orgs</span>
          </div>
          <div className="serif" style={{fontSize:48, lineHeight:1}}>{p.price}</div>
          <div className="divider"/>
          <div className="stack gap-2">
            {p.features.map(f => (
              <div key={f} className="row gap-2"><Icon name="check" size={14}/><span style={{fontSize:13}}>{f}</span></div>
            ))}
          </div>
          <button className="btn btn-light btn-sm" style={{marginTop:6, justifyContent:"center"}}>Éditer le plan</button>
        </div>
      ))}
    </div>
  </div>
);

const AdminQueue = () => (
  <div className="panel" style={{overflow:"hidden"}}>
    <div className="row between" style={{padding:"24px 28px"}}>
      <h3>File de modération <span className="mono muted">(7 en attente)</span></h3>
      <div className="row gap-2">
        <button className="chip chip-active">Tout</button>
        <button className="chip">Parcours</button>
        <button className="chip">Photos</button>
        <button className="chip">Comptes</button>
      </div>
    </div>
    <table className="table">
      <thead><tr><th>Élément</th><th>Soumis par</th><th>Type</th><th>Reçu</th><th>Statut</th><th>Actions</th></tr></thead>
      <tbody>
        {[
          ["Parcours « Métiers d'eau »", "Ville de Nivelles", "Parcours", "12 min", "À valider"],
          ["Photo — Verrerie de Wavre", "Y. Defossé", "Photo", "45 min", "Signalée"],
          ["Bio — Maïté Lambin", "M. Lambin", "Profil", "1 h", "À valider"],
          ["Demande marque blanche", "Commune de Lasne", "Compte", "3 h", "En attente"],
          ["Artiste Camille Orban", "Brabant Culture", "Artiste", "1 j", "À valider"]
        ].map((row,i)=>(
          <tr key={i}>
            <td>{row[0]}</td><td>{row[1]}</td>
            <td><span className="chip">{row[2]}</span></td>
            <td className="mono muted">{row[3]}</td>
            <td><span className="badge badge-soon">{row[4]}</span></td>
            <td>
              <div className="row gap-2">
                <button className="btn btn-light btn-sm">Voir</button>
                <button className="btn btn-light btn-sm" style={{color:"var(--sage-d)"}}>Approuver</button>
                <button className="btn btn-light btn-sm" style={{color:"var(--terracotta-d)"}}>Refuser</button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const AdminUsers = () => (
  <div className="panel" style={{overflow:"hidden"}}>
    <div className="row between" style={{padding:"24px 28px"}}><h3>Utilisateurs</h3><button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Inviter</button></div>
    <table className="table">
      <thead><tr><th>Nom</th><th>Rôle</th><th>Organisation</th><th>Dernière connexion</th><th></th></tr></thead>
      <tbody>
        {[
          ["Marie Dupuis","Super-admin","Parcours BW","il y a 2 min"],
          ["Sophie Levêque","Organisateur","Centre culturel de Genappe","il y a 18 min"],
          ["Tomas Wery","Artiste","Verrerie de Wavre","il y a 1 h"],
          ["Hubert Decroly","Artiste","Ville de Nivelles","hier"],
          ["Jean-Luc Pestiau","Organisateur","Brabant Culture Réseau","il y a 3 j"]
        ].map((r,i)=>(
          <tr key={i}>
            <td><div className="row gap-3"><div className={"ph ph-paint-"+((i%6)+1)} style={{width:32,height:32,borderRadius:50}}/>{r[0]}</div></td>
            <td><span className="chip">{r[1]}</span></td>
            <td>{r[2]}</td>
            <td className="mono muted">{r[3]}</td>
            <td style={{textAlign:"right"}}><button className="btn btn-icon btn-light" style={{width:32,height:32}}><Icon name="edit" size={12}/></button></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const AdminStats = () => (
  <div className="stack gap-6">
    <div className="row gap-4">
      <AdminKpi label="Visiteurs uniques" value="12 480" delta="+38%" chart={<SparkLine/>}/>
      <AdminKpi label="Itinéraires créés" value="892" delta="+22%" chart={<SparkLine color="var(--ochre)"/>}/>
      <AdminKpi label="Partages sociaux" value="2 145" delta="+14%" chart={<SparkLine color="var(--sage)"/>}/>
      <AdminKpi label="Taux de rebond" value="22%" delta="-4 pts" chart={<SparkLine color="var(--slate)"/>}/>
    </div>
    <div className="panel" style={{padding:28}}>
      <h3 style={{marginBottom:24}}>Fréquentation sur 4 semaines</h3>
      <BigChart/>
    </div>
    <div className="row gap-4">
      <div className="panel" style={{flex:1, padding:28}}>
        <h4 style={{marginBottom:16}}>Top parcours</h4>
        {window.PA_DATA.parcours.slice(0,5).map((p,i) => (
          <div key={p.id} className="row between" style={{padding:"12px 0", borderBottom:"1px dashed var(--line)"}}>
            <div className="row gap-3">
              <span className="mono muted" style={{width:18}}>{i+1}</span>
              <span style={{fontSize:14}}>{p.title}</span>
            </div>
            <div className="row gap-3">
              <div style={{width:120, height:6, borderRadius:99, background:"var(--paper-3)", position:"relative"}}>
                <div style={{position:"absolute", inset:0, right:`${(i*10)}%`, background:"var(--terracotta)", borderRadius:99}}/>
              </div>
              <span className="mono muted" style={{width:60, textAlign:"right"}}>{(2400-i*340).toLocaleString("fr-BE")}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="panel" style={{flex:1, padding:28}}>
        <h4 style={{marginBottom:16}}>Top communes</h4>
        {window.PA_DATA.communes.slice(0,6).map((c,i) => (
          <div key={c.id} className="row between" style={{padding:"12px 0", borderBottom:"1px dashed var(--line)"}}>
            <span style={{fontSize:14}}>{c.name}</span>
            <span className="mono muted">{(1200-i*140).toLocaleString("fr-BE")} visites</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const AdminSettings = () => (
  <div className="stack gap-6">
    <div className="panel" style={{padding:32}}>
      <h3 style={{marginBottom:8}}>Paramètres généraux</h3>
      <p className="muted" style={{marginTop:0, maxWidth:580}}>
        Paramètres globaux de la plateforme. Modifications visibles immédiatement pour toutes les organisations.
      </p>
      <div className="divider" style={{margin:"24px 0"}}/>
      <div className="stack gap-5" style={{maxWidth:680}}>
        {[
          ["Nom public", "Parcours d'artistes — Brabant wallon"],
          ["Région couverte", "Province du Brabant wallon"],
          ["Langues supportées", "FR (NL prochainement)"],
          ["Email de support", "bonjour@parcours.bw"]
        ].map(([k,v]) => (
          <div key={k} className="row between" style={{paddingBottom:16, borderBottom:"1px dashed var(--line)"}}>
            <div className="stack gap-1">
              <span className="mono muted">{k}</span>
              <span style={{fontSize:14}}>{v}</span>
            </div>
            <button className="btn btn-light btn-sm">Modifier</button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

window.AdminPage = AdminPage;
window.SideNav = SideNav;
window.AdminHeader = AdminHeader;
window.AdminKpi = AdminKpi;
window.SparkLine = SparkLine;
window.BigChart = BigChart;
